import classNames from 'classnames';
import {useLocation, useNavigate} from 'react-router-dom';
import {googleAnalyticsInstance} from 'utilities/helper/googleAnalitics';
import {
  FarmEvents,
  WholesalerEvent,
} from 'utilities/helper/googleAnalitics/EventHelper';
const Items = ({icon, isActive, title, router, role}: IFooterItemsProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  const isFarm = location.pathname.includes('farm');
  return (
    <>
      <i
        onClick={() => {
          googleAnalyticsInstance.eventGoogleAnalytics(
            isFarm ? FarmEvents[role] : WholesalerEvent[role],
          );
          navigate(router);
        }}
        className={classNames(
          isActive
            ? icon === 'icon-home_deselect'
              ? `icon-home text-primary`
              : `${icon}_select text-primary`
            : icon,
          'm-auto text-gray-2 text-2xl ',
        )}
      />
      <small
        className={classNames(
          ' font-extrabold text-gray-2 mt-2',
          isActive && 'text-primary',
        )}
      >
        {title}
      </small>
    </>
  );
};

export default Items;
